<template>
  <v-select
    multiple
    :label="label"
    v-model="rights"
    :items="props.options">
  </v-select>
</template>

<script lang="ts" setup>
import { useTranslation } from "i18next-vue";
import { computed } from "vue";

const { t } = useTranslation();

const model = defineModel<number>();

const props = defineProps<{
  options: { value: number; title: string }[];
  label: string;
}>();

const rights = computed({
  get: () => {
    return props.options
      .filter((option) => option.value & model.value)
      .map((option) => option.value);
  },
  set: (value) => {
    console.log(value);
    model.value = value.reduce((result, item) => item ^ result, 0);
    console.log(model.value);
  }
});
</script>
